module.exports = __webpack_public_path__ + "img/yes.d1a8edad.svg";